import {
  getBolDetails,
  getComplianceDetails,
  getLoadStatusDetails,
  getSubmissionDeadline,
  getHblDetails,
  setHSCode,
  fetchExceptionData,
  multipleBills,
  getPartialBolDetails
} from "@/common/service/apiaggregator/bolApiAgreegatorService.js";

import { getManifestDetails, updateSubmittedManifest } from "@/common/service/apiaggregator/manifestAgreegatorService";
import { constants } from "@/lib/CONSTANTS.js";

const getComplianceList = bolNumber => {
  return (state?.bolRecordsNew?.shipments || [])
    .filter(shipmentItem => shipmentItem.shipmentNumber === bolNumber)
    .flatMap(shipmentItem =>
      (shipmentItem.route?.routeLinks || []).flatMap(routeItem =>
        (routeItem.compliances || []).map(compItem => ({
          complianceId: compItem
        }))
      )
    );
};

const state = {
  bolNumber: null,
  bolRecordsNew: {},
  bolRecordsError: null,
  bolRecordsLoader: false,
  refreshBolLoader: false,
  hblRecords: {},
  ORRShipments: [],
  operationalShipment: [],
  consignmentType: "BOL",
  masterNumber: "",
  activeConsignmentId: ""
};

const mutations = {
  setBolRecords(state, result) {
    state.bolRecordsNew = result;
    //status possible values as per API: Approved | Cancelled | Not Found
    //state.isSearchedBolCancelled = result && result.status && result.status.toLowerCase() === "cancelled" ? true : false;
  },
  setHBLRecords(state, result) {
    state.hblRecords = result;
  },

  setBol(state, bol) {
    state.bolNumber = bol;
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "has Error" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  },
  setLoadingState(state, param) {
    state[`${param.type}Loader`] = param.value;
  },
  setEnableBackButton(state, value) {
    state.enableBackButton = value;
  },
  setOpeartionalShipment(state, value) {
    if (state.operationalShipment.indexOf(value) === -1) {
      state.operationalShipment.push(value);
    }
  },
  resetOpeartionalShipment(state, value) {
    state.operationalShipment = value;
  },
  setORR(state, value) {
    if (state.ORRShipments.indexOf(value) === -1) {
      state.ORRShipments.push(value);
    }
  },
  resetORRShipment(state, value) {
    state.ORRShipments = value;
  },
  setConsignmentType(state, value) {
    state.consignmentType = value;
  },
  setMasterNumber(state, value) {
    state.masterNumber = value;
  },
  setActiveConsignmentId(state, value) {
    state.activeConsignmentId = value;
  }
};

const actions = {
  async fetchBolDetails({ commit, rootState }, bolNumber) {
    commit("setLoadingState", { type: "bolRecords", value: true });
    commit("setBolRecords", null);
    commit("setHBLRecords", null);
    commit("resetORRShipment", []);
    commit("resetOpeartionalShipment", []);
    try {
      let rawData;
      let data = {};
      rawData = await getBolDetails(bolNumber, state.consignmentType, true, state.masterNumber);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "bolRecords",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
        data.shipments.forEach(element => {
          element.parties.forEach(pItem => {
            pItem.showMore = false;
            for (const cItem of rootState.commonStore.countryList) {
              if (
                pItem.customerInformation &&
                pItem.customerInformation.country &&
                cItem.name === pItem.customerInformation.country
              ) {
                pItem.countryName = cItem.value;
              }
            }
          });

          if (element.isORR === true && (element.isSplit === false || element.isSplit === null || !element.isSplit)) {
            commit("setORR", element.shipmentNumber);
          } else if (element.isSplit === true) {
            //commit("setSplitFlagButton", true);
          }
        });

        if (data.containerMap) {
          for (const cargoItem of data.containerMap) {
            if (cargoItem && cargoItem.equipments) {
              for (const equipItem of cargoItem.equipments) {
                if (equipItem && equipItem.isBelongsToOperationalShipment === true) {
                  commit("setOpeartionalShipment", equipItem.shipmentNumber);
                }
              }
            }
            /* if (cargoItem.cargos) {
              for (const item of cargoItem.cargos) {
                if (item.hsCode) {
                  item.oldHSCode = item.hsCode;
                }
              }
            }*/
          }
        }

        commit("setBolRecords", data);
      }
      /* TODO:: Fetching complaince data for each item */
      /* TODO::Cargo and eqipment */
      if (state.bolNumber != bolNumber) {
        commit("setBol", bolNumber);
      }

      commit("setErrorState", { type: "bolRecords", error: "" });
      commit("setLoadingState", { type: "bolRecords", value: false });
    } catch (error) {
      commit("setBol", null);
      commit("setBolRecords", null);
      commit("setErrorState", { type: "bolRecords", error });
      commit("setLoadingState", { type: "bolRecords", value: false });
    }
  },
  //Function to Load the compliacnce Details
  fetchComplianceDetails(_, cParams) {
    let rawData;
    const { complianceID, bolNumber, consignmenTypeOpted = "BOL", masterNumber = "" } = cParams;

    rawData = getComplianceDetails(bolNumber, complianceID, consignmenTypeOpted, masterNumber);
    if (rawData.status > 200 && rawData.status <= 299) {
      return false;
    } else {
      return rawData;
    }
  },
  fetchLoadStatus(_, cParams) {
    let rawData;
    rawData = getLoadStatusDetails(cParams);
    if (rawData.status > 200 && rawData.status <= 299) {
      return false;
    } else {
      return rawData;
    }
  },
  //Function to Load the Submission Deadline for a  Complieance
  getSubmissionDeadLineDate(_, cParams) {
    let rawData;
    rawData = getSubmissionDeadline(cParams);
    if (rawData.status > 200 && rawData.status <= 299) {
      return false;
    } else {
      return rawData;
    }
  },
  setBOLdetails({ commit }) {
    commit("setHBLRecords", null);
  },
  async fetchHBLdetails({ commit, rootState }, bolNumber) {
    try {
      let rawData;
      let data = {};
      rawData = await getHblDetails(bolNumber, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setHBLRecords", {
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
        data.parties.forEach(pItem => {
          pItem.showMore = false;
          for (const cItem of rootState.commonStore.countryList) {
            if (
              pItem.customerInformation &&
              pItem.customerInformation.country &&
              cItem.name === pItem.customerInformation.country
            ) {
              pItem.countryName = cItem.value;
            }
          }
        });
        data.consignmentType = "HBL";
        commit("setHBLRecords", data);
      }
    } catch (error) {
      //TODO::Error handling need to discuss
    }
  },
  updateContainerdetails({ commit }, data) {
    commit("setHBLRecords", data);
  },
  //Function to Load the Submission Deadline for a  Complieance
  async updateHB6CodeValue({ rootState }, cParams) {
    let rawData;
    const complianceWithLinkedDates = getComplianceList(cParams.bolNumber);
    cParams.body = {
      complianceWithLinkedDates,
      userName: rootState.userAccount.loginDetails.name,
      userId: rootState.userAccount.loginDetails.idTokenClaims.MaerskID
    };
    rawData = await setHSCode(cParams);
    if (rawData.status > 200 && rawData.status <= 299) {
      return false;
    } else {
      return rawData;
    }
  },
  //Function to Load the Exceptions Details
  fetchExceptionDetails(_, bolNumber) {
    let rawData;
    rawData = fetchExceptionData(bolNumber);
    if (rawData.status > 200 && rawData.status <= 299) {
      return false;
    } else {
      return rawData;
    }
  },

  async getBookingNumberDetails(_, bolNumber) {
    let rawData;
    rawData = await multipleBills(bolNumber);
    if (rawData.status > 200 && rawData.status <= 299) {
      return [];
    } else {
      return rawData;
    }
  },

  async fetchComplianceDetailsList(_, params) {
    try {
      let rawData,
        data = [],
        queryParams;

      queryParams = {
        compId: params.compId ? params.compId : "",
        compPort: params.compPort ? params.compPort : "",
        clearanceLocation: params.clearanceLocation ? params.clearanceLocation : "",
        loadPort: params.loadPort ? params.loadPort : "",
        complianceType: params.complianceType ? params.complianceType : "",
        stageValue: params.stageValue ? params.stageValue : "",
        statusValue: params.statusValue ? params.statusValue : "",
        customNotificationStatus: params.customNotificationStatus ? params.customNotificationStatus : [],
        okToLoadValue: params.okToLoadValue ? params.okToLoadValue : "",
        bolNumber: params.bolNo ? params.bolNo : "",
        consignmentType: params.consignmentType ? params.consignmentType : "",
        page: params.page ? params.page : 1,
        size:
          params && params.pageSize && params.pageSize > constants.pageSettings.manifest.searchResultsPerPage
            ? params.pageSize
            : constants.pageSettings.manifest.searchResultsPerPage,
        isManuallyTriggered: params.isManuallyTriggered === true ? true : false,
        sourceType: params.sourceType ? params.sourceType : "normal",
        applicableReferenceTypes: params.applicableReferenceTypes ? params.applicableReferenceTypes : "",
        isBolLevelReferenceExists: params.isBolLevelReferenceExists ? true : false,
        bda: params.bda ? params.bda : "",
        searchType: params.searchType ? params.searchType : "BOL",
        sourcePage: params.sourcePage ? params.sourcePage : "BOL"
      };

      rawData = await getManifestDetails(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
      } else {
        data = await rawData.json();
      }

      return data;
    } catch (error) {
      return false;
    }
  },

  async manifestBtnSubmission({ commit, rootState }, qparams) {
    try {
      let rawData,
        data = [];

      const {
        complianceId,
        firstEventLinkedDate,
        complianceType,
        compPort,
        loadPort,
        submissionScopes,
        bolNumber
      } = qparams;

      const cmpParams = {
        complianceId,
        body: {
          firstEventLinkedDate,
          port: compPort,
          userName: rootState.userAccount.loginDetails.name,
          userId: rootState.userAccount.loginDetails.idTokenClaims.MaerskID,
          submissionScopes
        },
        complianceType,
        loadPort,
        isSelectedAllBol: false,
        bolNumbers: new Array(bolNumber)
      };
      rawData = await updateSubmittedManifest(cmpParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "manifestSub",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
        return data;
      }
    } catch (error) {
      return false;
    }
  },
  /**
   * Fetches partial BOL details based on provided parameters and commits them to the store.
   *
   * Behavior:
   * - Calls `getPartialBolDetails` using the master BOL number and selected value.
   * - If response indicates an error (status > 200), clears HBL records.
   * - Otherwise, processes the returned shipment and party data:
   *    - Adds `showMore` flag to each party item.
   *    - Maps country names using `commonStore.countryList`.
   * - Commits the processed data to the store via `setHBLRecords`.
   * - In case of any fetch error, commits `null` to clear records.
   *
   * @param {Object} context - Vuex action context.
   * @param {Function} context.commit - Vuex commit function.
   * @param {Object} context.rootState - The root state of the Vuex store.
   * @param {Object} cParams - Parameters used for fetching BOL data.
   * @param {string} cParams.masterBolNumber - Master BOL number.
   * @param {string} cParams.val - Selected HBL or MBL value.
   */
  async fetchPartialBolDetails({ commit, rootState }, cParams) {
    try {
      let rawData;
      let data = {};
      rawData = await getPartialBolDetails(cParams.masterBolNumber, state.consignmentType, true, cParams.val);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setHBLRecords", null);
      } else {
        data = await rawData.json();
        data.shipments.forEach(element => {
          element.parties.forEach(pItem => {
            pItem.showMore = false;
            for (const cItem of rootState.commonStore.countryList) {
              if (
                pItem.customerInformation &&
                pItem.customerInformation.country &&
                cItem.name === pItem.customerInformation.country
              ) {
                pItem.countryName = cItem.value;
              }
            }
          });
        });

        commit("setHBLRecords", data);
      }
    } catch (error) {
      commit("setHBLRecords", null);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
